import React from 'react';
import moment from 'moment';

import IncomingMsgShimmerComponent from '../common/genericComponents/redesign/shimmerWithEmptyImageComponent/incomingMsgShimmerComponent';
import OutgoingMsgShimmerComponent from '../common/genericComponents/redesign/shimmerWithEmptyImageComponent/outgoingMsgShimmerComponent';
import ParticipantChatNameComponent from '../chatComponents/participantChatNameComponent';
import Spinner from '../common/genericComponents/spinner';

import FileSharingService from '../../services/restServices/FileSharingService';
import ImageSharingService from '../../services/restServices/ImageSharingService';

import VIDABOO_CONSTANTS from '../../config/consts';
import arrowIcon from '../../assets/svg/icons/right-arrow.svg';
import FileIcon from '../../assets/svgComponents/FileIcon';

import './getFileMessageComponent.css';

class GetFileMessageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tempUrl: undefined,
      meta: {},
      downloading: false,
      showImagePopup: false,
      srcImagePopup: '',
      base64: undefined,
      fileSendTime: '',
      isFileLoaded: false,
    };
  }

  async componentDidMount() {
    if (VIDABOO_CONSTANTS.NATIVE_APP) {
      return;
    }
    if (this.props.mediaMessageMeta) {
      let meta = this.getParseMeta(this.props.mediaMessageMeta);
      if (!meta) return;
      this.setState({meta});
      if (this?.props?.type === 'media') {
        const sendTime = moment(this.props.message.senderCreationTime).format(
          'h:mm A',
        );
        this.setState({fileSendTime: sendTime});
      }
      if (meta?.fileType && meta.fileType.includes('image')) {
        const tempUrl = await this.getThumbnail(meta.mediaMessageId);
        this.setState({tempUrl});
      } else {
        this.setState({isFileLoaded: true});
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextProps.mediaMessageMeta !== this.props.mediaMessageMeta ||
      nextState.tempUrl !== this.state.tempUrl ||
      JSON.stringify(nextState.meta) !== JSON.stringify(this.state.meta) ||
      nextState.isFileLoaded !== this.state.isFileLoaded ||
      nextState.downloading !== this.state.downloading
    ) {
      return true;
    } else {
      return false;
    }
  }

  getThumbnail = async (msgId) => {
    const response = await ImageSharingService.getImageByMsgId(msgId);
    return response.data.mmDto?.tempThumbAccessibleUrl
      ? VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE +
          response.data.mmDto?.tempThumbAccessibleUrl
      : response.data.mmDto?.tempThumbAccessibleUrl;
  };
  getImageUrl = async (msgId) => {
    const response = await ImageSharingService.getImageByMsgId(msgId);
    this.sendDataToParentForImagePopup(
      VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE +
        response.data.mmDto?.tempAccessibleUrl,
      true,
    );
  };
  sendDataToParentForImagePopup = (srcImagePopup, showImagePopup) => {
    if (this.props && this.props.setDataForImagePopup) {
      this.props.setDataForImagePopup({
        srcImagePopup,
        showImagePopup,
        meta: {
          ...this.state.meta,
          onCancel: () => {
            this.sendDataToParentForImagePopup('', false);
          },
        },
      });
    }
  };

  getParseMeta = (mediaMessageMeta) => {
    let meta = mediaMessageMeta;
    try {
      meta = JSON.parse(meta);
    } catch (error) {
      console.debug(error, 'error in parse meta data', meta);
      meta = {
        mediaMessageId: meta,
      };
    }
    return meta;
  };

  getFileTempUrl = async (meta) => {
    this.setState({downloading: true}, async () => {
      let base64 = this.state.base64;

      if (!base64) {
        base64 = await this.getTempUrl(meta.mediaMessageId);
      }

      let element = document.createElement('a');
      element.setAttribute('href', base64);
      element.setAttribute('download', meta.fileName);
      element.setAttribute('target', '_blank');
      document.body.appendChild(element);
      element.click();

      document.body.removeChild(element);
      this.setState({base64, downloading: false});
    });
  };

  getTempUrl = async (mediaMessageId) => {
    const response = await FileSharingService.getFileByMsgId(mediaMessageId);
    const img = await fetch(
      VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE +
        response.data.tempAccessibleUrl,
      {method: 'GET'},
    );
    let base64 = await img.text();
    return base64;
  };
  handleFileOrImageClick = async () => {
    const meta = this.state.meta;
    if (meta.fileType.includes('image')) {
      await this.getImageUrl(meta.mediaMessageId);
    } else {
      this.getFileTempUrl(meta);
    }
  };

  render() {
    const {meta, downloading, fileSendTime} = this.state;

    return (
      <div>
        <div
          id={meta.mediaMessageId}
          className={`et-n-file-msg-container  ${
            this.props.align === 'right'
              ? 'et-n-file-msg-container-right '
              : 'et-n-file-msg-container-left '
          }  ${downloading ? 'et-n-file-msg-container--disable' : ''} ${this.state.isFileLoaded && this.props.participantName ? 'et-n-file-sender-name-img-wrap' : ''}`}
          onClick={this.handleFileOrImageClick}
          data-id={meta.mediaMessageId}>
          {meta &&
          meta.fileType &&
          meta.fileType.includes('image') &&
          this.state.tempUrl ? (
            <>
              <div
                className={`et-n-file-msg-link ${
                  downloading ? 'et-n-send-file-downloading' : ''
                }`}>
                {this.state.isFileLoaded && this.props.participantName && (
                  <ParticipantChatNameComponent
                    participantName={this.props.participantName}
                  />
                )}
                <img
                  src={this.state.tempUrl}
                  alt={'dropped-file'}
                  className={
                    this.props.align === 'right'
                      ? 'et-n-file-msg-image-right'
                      : 'et-n-file-msg-image-left'
                  }
                  style={{
                    visibility: this.state.isFileLoaded ? 'visible' : 'hidden',
                    maxWidth: this.state.isFileLoaded ? '220px' : '0px', //need to set max-width because image is shown on ui before isFileLoaded is updated inside onLoad. Not setting this will lead to have both image and shimmer for few milliseconds.
                  }}
                  loading="lazy"
                  onLoad={() => {
                    this.setState({isFileLoaded: true});
                  }}
                />
                {!this.state.isFileLoaded && (
                  <>
                    {this.props.align === 'right' ? (
                      <OutgoingMsgShimmerComponent />
                    ) : (
                      <IncomingMsgShimmerComponent />
                    )}
                  </>
                )}
              </div>
            </>
          ) : (
            <div
              className={`et-n-file-msg-link ${
                this.props.align === 'right'
                  ? 'et-n-file-msg-link--right'
                  : 'et-n-file-msg-link--left'
              }`}>
              {this.props.participantName && (
                <ParticipantChatNameComponent
                  participantName={this.props.participantName}
                />
              )}
              <div className="et-n-file-msg-icon-name-size-wrap">
                <div
                  className={` et-n-file-msg-icon ${
                    downloading ? 'et-n-send-file-downloading' : ''
                  }`}>
                  {/* <img src={FileIconInChat} alt={'file-icon'} /> */}
                  {!this.state.isFileLoaded || downloading ? (
                    <div className="et-n-file-msg-file-spinner-wrap et-n-white-bg-spinner et-n-smaller-spinner">
                      <Spinner />
                    </div>
                  ) : (
                    <FileIcon
                      fillColor={
                        this.props.align === 'right' ? '#fff' : '#2961FA'
                      }
                    />
                  )}
                </div>
                <div
                  className={
                    this.props.align === 'right'
                      ? 'et-n-file-msg-meta-wrap--right'
                      : 'et-n-file-msg-meta-wrap--left'
                  }>
                  <div className="et-n-file-msg-file-name">{meta.fileName}</div>
                  <div className="et-n-file-msg-file-size">
                    {(meta.fileSize / 1024).toFixed(2)}kb
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        {this.props.type === 'media' && (
          <div className="et-n-pm-wrap">
            <img
              onClick={() => this.props.goToMessage(this.props.chatMessageId)}
              src={arrowIcon}
              className="et-n-drmbil-arrow-img"
              alt="arrowIcon"
            />
            <div className="et-n-pm-time-format-wrap">
              <p className="et-n-pm-message-time"></p>
              {/* keep the above so it shows teh time on the right */}
              <p className="et-n-pm-message-time">{fileSendTime}</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}
// GetFileMessageComponent.whyDidYouRender = true;
export default GetFileMessageComponent;
